/* eslint-disable */
/**
 * Implement Google Analytics Snippets.
 *
 * The injected snippets are consitent for all Everest verticals. Choosi (white
 * label) and CTM have separate IDs.
 */

import { pageContext } from 'ctm-util-functions';

const favIcon = () => {
    const baseAssetsPath = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath();
    const brandCode = process.env.EVEREST_THEME?.trim();
    let faviconPath = `${baseAssetsPath}/brand/${brandCode}/images/`;
    return `<link rel="icon" href="${faviconPath}favicon.ico">`;
};

const AppleTouchIcon = (properties) => {
    const baseAssetsPath = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath();
    const brandCode = process.env.EVEREST_THEME?.trim();
    let touchIconPath = `${baseAssetsPath}/brand/${brandCode}/images/`;
    const sizesProp = properties.size ? ` sizes="${properties.size}"` : '';
    return `<link rel="apple-touch-icon"${sizesProp} href="${touchIconPath}touch-icons/${properties.image}">`;
};

const polyfillIE = (properties) => {
    const baseAssetsPath = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath();
    if (properties.folderPath.indexOf(baseAssetsPath) === -1) {
        properties.folderPath = properties.folderPath.replace('/evt/assets', baseAssetsPath);
    }
    return `<script src="${properties.folderPath}/min/polyfill.min.js"></script>`;
};

const newRelicScript = (properties) => {
    const baseAssetsPath = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath();
    return `<script src="${baseAssetsPath}/dist/nr-header.js"></script>`;
};

const requestAnimationFrame = (properties) => {
    const baseAssetsPath = pageContext.getProps().models.pageSchemaModel.getBaseAssetsPath();
    if (properties.folderPath.indexOf(baseAssetsPath) === -1) {
        properties.folderPath = properties.folderPath.replace('/evt/assets', baseAssetsPath);
    }
    return `<script src="${properties.folderPath}/min/requestAnimationFrame.min.js"></script>`;
};

const unsupportedBrowser = (properties) => {
    return `var $buoop = {
                vs: {
                    i: ${properties.i},
                    f: ${properties.f},
                    o: ${properties.o},
                    s: ${properties.s},
                    c: ${properties.c}
                },
                test: ${properties.test},
                reminder: ${properties.reminder},
                noclose: ${properties.noclose},
                api: 4
            };

            function $buo_f() {
                var e = document.createElement("script");
                e.src = "//browser-update.org/update.min.js";
                document.body.appendChild(e);
            };
            try {
                document.addEventListener("DOMContentLoaded", $buo_f,false);
            } catch(e) {
                window.attachEvent("onload", $buo_f);
            }
    `;
};

const SnippetTemplates = {
    favIcon,
    AppleTouchIcon,
    polyfillIE,
    newRelicScript,
    requestAnimationFrame,
    unsupportedBrowser
};

export { SnippetTemplates };
